<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="full-table">
    <app-data-table-ajax *ngIf="role?.id && userName?.username"
        #dataTableAjax
        url="/roles/{{role?.id}}/users/{{ userName?.username}}/scopes"
        limit="50"
        [columns]="columns"
        [displaySearch]="false">
    </app-data-table-ajax>
</div>



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-row/user-details-row.component.html